import { makeStyles } from "@material-ui/core";
import {
  createTechDocsAddonExtension,
  TechDocsAddonLocations,
  useTechDocsReaderPage,
} from "@backstage/plugin-techdocs-react";
import { createPlugin } from "@backstage/core-plugin-api";
import { getDocType } from "./constants";

const makeVariant = (palette: any, borderStyle: string) => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  padding: "8px 16px",
  background: palette.main,
  color: palette.contrastText,
  fontWeight: 500,
  fontSize: "0.875rem",
  borderBottom: `3px ${borderStyle} ${palette.dark}`,
});

const useStyles = makeStyles((theme) => ({
  official: makeVariant(theme.palette.info, "solid"),
  engineering: makeVariant(theme.palette.warning, "dashed"),
}));

export const DocTypeBannerComponent = () => {
  const classes = useStyles();
  const { entityMetadata } = useTechDocsReaderPage();

  if (!entityMetadata.value) return null;

  const docType = getDocType(
    entityMetadata.value.metadata?.annotations?.[
      "backstage.io/managed-by-location"
    ],
  );

  if (docType === "official") {
    return (
      <div className={classes.official}>
        <span role="img" aria-label="check mark">
          ✅
        </span>
        Official documentation — aka Golden Path
      </div>
    );
  }

  if (docType === "engineering") {
    return (
      <div className={classes.engineering}>
        <span role="img" aria-label="warning">
          ⚠️
        </span>
        Engineering docs — advisory only, may not reflect current state
      </div>
    );
  }

  return null;
};

const docTypeBannerPlugin = createPlugin({
  id: "doc-type-banner",
});

export const DocTypeBanner = docTypeBannerPlugin.provide(
  createTechDocsAddonExtension({
    name: "DocTypeBanner",
    location: TechDocsAddonLocations.Subheader,
    component: DocTypeBannerComponent,
  }),
);
